import { defineComponent } from "vue";
import FrequencyWatch from "../../CentralCalendar/FrequencyWatch/FrequencyWatch.vue";
import HuvSfvStatusReport from "../../CentralCalendar/HuvSfvStatusReport/HuvSfvStatusReport.vue";
import EmployeeSchedule from "../EmployeeSchedule/EmployeeSchedule.vue";
import PatientSchedule from "../PatientSchedule/PatientSchedule.vue";

interface Report {
    name: string;
    routeName: string;
    description: string;
    path: string;
}
interface ReportSection {
    title: string;
    reports: Report[];
}
export default defineComponent({
    name: "ReportCenter",
    directives: {},
    data(vm) {
        return {
            search: "",
            sections: [
                {
                    title: "Patient Reports",
                    reports: [
                        //uncomment once this feature is created
                        // {
                        //     name: "Patient/Client Census"
                        // }
                    ]
                },
                {
                    title: "Scheduled Reports",
                    reports: [
                        {
                            path: "/axxess-central/reports/employee-schedule",
                            component: EmployeeSchedule,
                            name: "Employee Schedule",
                            meta: {
                                menuName: "Employee Schedule",
                                navItem: "tabEmployeeSchedule",
                                showAxxessCentral: true,
                                description:
                                    "Displays a list of tasks scheduled for employees within a specified date range. The report can be filtered to show scheduled tasks for any period within a 7-day window. It supports efficient schedule management and operational oversight and can be exported in Excel or PDF format.",
                                parameters: "Branch, Task, Status, Employee, Title, Date Range",
                                reportIncludes:
                                    "View, Organization, Branch, Task Status, Employee, Start Date, Report Format."
                            }
                        },
                        {
                            path: "/axxess-central/reports/patient-schedule",
                            component: PatientSchedule,
                            name: "Patient Schedule",
                            meta: {
                                menuName: "Patient Schedule",
                                navItem: "tabPatientSchedule",
                                showAxxessCentral: true,
                                description:
                                    "Displays a list of tasks scheduled for patients within a specified date range. The report can be filtered to show scheduled tasks for any period within a 7-day window. It supports efficient schedule management and operational oversight and can be exported in Excel or PDF format.",
                                parameters: "Branch, Task, Status, Patient, Title, Date Range",
                                reportIncludes:
                                    "View, Organization, Branch, Task Status, Patient, Start Date, Report Format."
                            }
                        },
                        {
                            path: "/axxess-central/schedule-center/frequency-watch",
                            component: FrequencyWatch,
                            name: "Frequency Watch",
                            meta: {
                                menuName: "Frequency Watch",
                                navItem: "tabFrequencyWatch",
                                showFrequencyWatch: true,
                                description:
                                    "Displays a list of patients who have visits scheduled over or under the ordered frequency for each active discipline for the patient. This report enables users to prevent survey deficiencies by ensuring visits are scheduled according to ordered frequencies. This is only applicable for the Home Health and Hospice solution only.",
                                parameters: "Branch, Team, Discipline",
                                reportIncludes:
                                    "Patient Name, Branch, Team, Discipline, Frequency, Frequency Status, Start Date, End Date, Visits Scheduled, Visits Ordered, Scheduled Variance, Tags, Actions"
                            }
                        },
                        {
                            path: "/axxess-central/schedule-center/hul-sfv-status-report",
                            component: HuvSfvStatusReport,
                            name: "HUV and SFV Status Report",
                            meta: {
                                menuName: "HUV and SFV Status Report",
                                navItem: "tabHUVandSFVStatusReport",
                                showHopeReport: true,
                                description:
                                    "Displays a list of patients with unscheduled or incomplete HOPE Update Visits and Symptom Follow-Up Visits, along with the number of days remaining before completion. This is only applicable for the Hospice solution.",
                                parameters: "Branch, Team, Task, HUV/SFV, Task Status",
                                reportIncludes:
                                    "Branch, Team, Patient Last Name, Patient First Name, MRN, Patient Status, Task, HUV/SFV, Task Status, Visit Date, Admission Date, Days Remaining"
                            }
                        }
                    ]
                },
                {
                    title: "Employee Reports",
                    reports: [
                        //uncomment once this feature is created
                        // {
                        //     name: "Employee Document or License"
                        // }
                    ]
                }
            ] as unknown as ReportSection[]
        };
    },
    computed: {
        filteredSections(): ReportSection[] {
            const term = this.search.trim().toLowerCase();
            if (!term) return this.sections;
            return this.sections.map((section) => ({
                ...section,
                reports: section.reports.filter((report) => report.name.toLowerCase().includes(term))
            }));
        }
    },
    methods: {
        //uncomment once landing issue resolves
        // openReport(path: string) {
        //     const { href } = this.$router.resolve(path);
        //     window.open(href, "_blank", "noopener noreferrer");
        // },
        openReport(path: string) {
            this.$router.push(path);
        },
        getReportTooltip(report) {
            return (
                "<strong>Description: </strong>" +
                report.meta?.description +
                "<br><br><strong>Parameters: </strong>" +
                report.meta?.parameters +
                "<br><br><strong>Report Includes: </strong>" +
                report.meta?.reportIncludes
            );
        }
    }
});
